import React, { useEffect, useContext } from 'react';
import Countdown from 'react-countdown';
import { useNavigate } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function PagesComingSoon() {
	const context = useContext(AppSettings);
	const navigate = useNavigate();
	let currentDate = new Date();
  let currentYear = currentDate.getFullYear();
  
  const submitForm = (e) => {
    e.preventDefault();
    
    navigate('/');
  };
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);
  
	return (
		<div className="coming-soon">
			<div className="flex-1">
				<div className="coming-soon-timer my-3">
					<Countdown 
						date={Date.now() + 1000000000}
						renderer={
							props =>
							<div className="is-countdown text-center">
								<div className="countdown-row countdown-show4">
									<div className="countdown-section">
										<div className="countdown-amount d-block">{props.days}</div>
										<div className="countdown-period d-block">Days</div>
									</div>
									<div className="countdown-section">
										<div className="countdown-amount d-block">{props.hours}</div>
										<div className="countdown-period d-block">Hours</div>
									</div>
									<div className="countdown-section">
										<div className="countdown-amount d-block">{props.minutes}</div>
										<div className="countdown-period d-block">Minutes</div>
									</div>
									<div className="countdown-section">
										<div className="countdown-amount d-block">{props.seconds}</div>
										<div className="countdown-period d-block">Seconds</div>
									</div>
								</div>
							</div>
						}
					/>
				</div>
				
				<div className="coming-soon-content">
					<div className="flex-1 mb-5">
						<h2 className="mb-3">We're coming soon!</h2>
						<p className="mb-5">We are working very hard on the new version of our site.<br /> It will bring a lot of new features. Stay tuned!</p>
						<form onSubmit={submitForm}>
							<div className="input-group mb-2 w-300px mx-auto">
								<input type="text" className="form-control" placeholder="Email Address" />
								<button type="submit" className="btn btn-theme fw-semibold">Subscribe</button>
							</div>
						</form>
						<div className="small text-body text-opacity-50">* Subscribe and get notified for latest news</div>
					</div>
				</div>
				<div className="text-center small mt-5 pt-1 mb-n5">
					&copy; { currentYear } SeanTheme Right Reserved
				</div>
			</div>
		</div>
	)
}

export default PagesComingSoon;